import { Radio, Row } from 'antd'
import { RadioChangeEvent } from 'antd/lib/radio'
import ProjectCreateButton from 'app/components/Core/Project/CreateButton'
import Table from 'app/components/Core/Project/Table'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import TabBar from 'app/components/UI-Elements/Layout/TabBar/TabBar'
import { useCurrentContactOrganization } from 'app/lib/hooks/useCurrent'
import useFilterParams from 'app/lib/hooks/useFilterParams'
import useTitle from 'app/lib/hooks/useTitle'
import useTranslation from 'app/lib/hooks/useTranslation'
import { PageProps } from 'app/pages/typing'
import { Routes } from 'app/routes/Routes'
import * as React from 'react'
import { useNavigate } from 'react-router-dom'

const ProjectIndex: React.FC<PageProps> = (props) => {
  const { title } = useTitle(props)
  const navigate = useNavigate()
  const contactOrganization = useCurrentContactOrganization()
  const { tRoute } = useTranslation({ scope: props.route.key })
  const { params, setSearchParams } = useFilterParams<{ scope: 'me' | 'all' }>()

  const { scope } = params

  const onRowClick = (project: IProject) => {
    navigate(Routes.Project.member(project.id.toString()).show)
  }

  const onFilter = (e: RadioChangeEvent) => {
    setSearchParams({ ...params, scope: e.target.value })
  }

  const getDefaultScopeValue = (): string => {
    if (contactOrganization.role === 'accounting') {
      return 'all'
    } else {
      return 'me'
    }
  }

  const defaultScope = getDefaultScopeValue()

  return (
    <Row>
      <If condition={contactOrganization}>
        <KCol card title={title} span={24}>
          <Table
            filters={
              <Radio.Group
                onChange={onFilter}
                defaultValue={scope || defaultScope}
                name="contact_id">
                <Radio.Button value="me" disabled={contactOrganization.role === 'accounting'}>
                  {tRoute({ id: 'my_projects' })}
                </Radio.Button>
                <Radio.Button value="all">{tRoute({ id: 'all_projects' })}</Radio.Button>
              </Radio.Group>
            }
            tableExtra={<ProjectCreateButton />}
            onRowClick={onRowClick}
            params={{
              scope: defaultScope
            }}
          />
        </KCol>
      </If>
      <TabBar selected={Routes.Project.collection().index} />
    </Row>
  )
}

export default ProjectIndex
